export const ALERT_CONSTANTS = {
    SET: 'ALERT_SET',
    RESET: 'ALERT_RESET',
};

export const set = payload => ({
    type: ALERT_CONSTANTS.SET,
    payload
});

export const handleSet = payload => async dispatch => {
    dispatch(set(payload));
};

export const handleReset = () => ({
    type: ALERT_CONSTANTS.RESET
});